//导入axios
import axios from 'axios';
import { Loading } from 'element-ui';
import Vue from 'vue';
let loading;
// 设置全局loading,ajax请求未完成显示loading效果
function startLoading() {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '拼命加载中...',
    background: 'rgba(255,255,255,0.5)',
  })
}
// 加载完成关闭loading
function endLoading() {    //使用Element loading-close 方法
  loading.close()
}

const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_API_URL || '/api',
  // 超时
  timeout: 50000
})
// axios设置请求拦截器,设置响应头token
service.interceptors.request.use(
  config => {
    startLoading()
    // config.headers.token = window.sessionStorage.getItem('token') //每次发送请求之前自动将在session中的token提取出来当做响应头header
    return config
  },
  err => {
    console.log(err)
  }
)
//axios设置响应拦截器
service.interceptors.response.use(res => {
  endLoading();
  let data = res.data //拦截处理响应结果，直接返回需要的数据
  const code = res.data.code || res.status;
  if (data && (data instanceof Blob)) {
    return data;
  }
  if (code === 401) {
    Vue.$magess.error('用户未登录')
    Vue.$router.push('/login')
  } else if (code !== 200) {
    if (data && data.message) {
      Notification.error({
        title: data.message
      })
    }
    return data
  } else {
    return data
  }
  return data
}, err => {
  Vue.$magess.error(err)
  console.log(err)
})


//把axios注册到Vue
Vue.prototype.$http = service
//关闭vue在console中的默认提示
Vue.config.productionTip = false
Vue.use(Loading);
export default service